// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAnbTCXZknDV-7PpyPzx8iA0P7B9KASGys",
    authDomain: "careadmin-stage.firebaseapp.com",
    projectId: "careadmin-stage",
    storageBucket: "careadmin-stage.appspot.com",
    messagingSenderId: "1049119591899",
    appId: "1:1049119591899:web:c79fe75d44a38b03b22bfe",
    measurementId: "G-SHTTRKPSMQ"
  },
  allowIndexing: false,
  subscription: {
    planId: "prod_PI4KJJ6wQgMWvo"
  },
  google: {
    calendar: {
      clientId: "1049119591899-sbakr4eu1jtevovp1urmtdbh0rkses9n.apps.googleusercontent.com",
      secret: "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"
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
